import axios from "axios";
import React, {use, useEffect, useState} from "react";
import '../../styles/global.css'; // Seu CSS global
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';

function Contato() {

  const { idcontato } = useParams();
  const navigate = useNavigate();
  const [contato, setContato] = useState(null);
  const loggedIn = sessionStorage.getItem('loggedIn');

  const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

  const [isLoadingMOD, setIsLoadingMOD] = useState(false);

  const now = new Date();
  const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
  
    const guid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
        
  const [campos, setCampos] = useState({
    IdContato: idcontato ? parseInt(idcontato) : null,
    cntNome: '',
    cntEmail: '',
    cntMensagem: '',
    cntCriadoEm: customFormatDate,
    cntCodigoGUID: guid + '-'+ Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
    cntLidaPor: '',
    cntLidaEm: '',
    cntObservacoes: '',
    novaResposta: ''
  });

  useEffect(() => {
    if (idcontato && parseInt(idcontato) > 0) {

      const dados = {
            IdContato: idcontato,
        };
        // console.log(dados);return;
      setIsLoadingMOD(true);
      axios
        .post(process.env.REACT_APP_API_URL + `/routes.php?metodo=obterContato`,
           dados,
            {
                headers: {
                "X-Access-Token": tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
          if (response.data && response.data[0].IdContato) {
            setContato(response.data[0]);
            setCampos({
              IdContato: response.data[0].IdContato,
              cntNome: response.data[0].cntNome,
              cntEmail: response.data[0].cntEmail,
              cntMensagem: response.data[0].cntMensagem,
              cntCriadoEm: response.data[0].cntCriadoEm,
              cntCodigoGUID: response.data[0].cntCodigoGUID,
              cntLidaPor: response.data[0].cntLidaPor,
              cntLidaEm: response.data[0].cntLidaEm,
              cntObservacoes: response.data[0].cntObservacoes,
              novaResposta: ''
            });
          } else {
            alert('Contato não encontrado.');
            navigate('/Contatos');
          }
          setIsLoadingMOD(false);
        })
        .catch(error => {
          console.error('Erro ao buscar contato:', error);
          alert('Ocorreu um erro ao buscar o contato. Por favor, tente novamente mais tarde.');
          setIsLoadingMOD(false);
          navigate('/Contatos');
        });
    }
  }, [idcontato]);

  function handleInputChange(event) {
    const { name, value } = event.target;
    setCampos(prevCampos => ({
      ...prevCampos,
      [name]: value
    }));
  }

  //console.log(campos);

  function handleFormSubmit(event) {
        event.preventDefault();
        setIsLoadingMOD(true);
    // Lógica para enviar o formulário de contato
    if (!campos.cntNome || !campos.cntEmail || !campos.cntMensagem) {
      alert('Por favor, preencha todos os campos antes de enviar.');
      setIsLoadingMOD(false);
      return;
    }

    axios
    .post(process.env.REACT_APP_API_URL +
        '/routes.php?metodo=novoContato', 
        campos, 
        { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } })
        .then(response => {
          //alert('Formulário enviado com sucesso!' + response.data.message);
          //console.log(response.data); return;
          axios
          .post(process.env.REACT_APP_API_URL + `/routes.php?metodo=obtemModeloEmailPorDescricao`,
            { emlDescricao: 'FormContato' },
            {
              headers: {
                "X-Access-Token": tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
              }
            }
          )
          .then(response => {
            if (response.data && response.data.IdModeloEmail) {
              //console.log(response.data); return;
              const modeloEmail = response.data;
              let mess = modeloEmail.emlCorpo;
              mess = mess.replace('[nome]', campos.cntNome);
              mess = mess.replace('[mensagem]', campos.cntMensagem);
              //console.log(mess); return;
              //let mess = '<span style="font-family: Arial, sans-serif; font-size: 14px;"><p>Olá </p><b>' + campos.cntNome + '</b>, <p>recebemos sua mensagem pelo formulário de contato com o seguinte conteúdo: </p><p><b>' + campos.cntMensagem + '</b></p></span>';
              mess = '<div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; padding: 10px;">' +
              '<img src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="Logo MGBE" style="width: 100px; margin-top: 20px;" />' +
              '<br /> ' + mess + '</div>';
              const dadosEmail = {
                nome: campos.cntNome,
                email: campos.cntEmail,
                assunto: modeloEmail.emlAssunto,
                mensagem: mess
              };
              //console.log(dadosEmail); return;
              axios
              .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                dadosEmail, 
                { headers: {
                          "X-Access-Token" : tokenAPI,
                          "Content-Type": "application/json; charset=UTF-8"
                      } })
              .then(response => {
                alert('Email de notificação enviado com sucesso!');
                //enviar cópia do email para a gestão
                if (pessoasAlerta.length > 0) {
                  for (const pessoa of pessoasAlerta) {
                    const dadosEmailGestao = {
                      nome: dadosEmail.nome,
                      email: pessoa.pesEmail,
                      assunto: 'CÓPIA DE CONTATO DO SITE MGBE - ' + dadosEmail.assunto,
                      mensagem: dadosEmail.mensagem
                    }
                    axios
                    .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                      dadosEmailGestao, 
                      { headers: {
                                "X-Access-Token" : tokenAPI,
                                "Content-Type": "application/json; charset=UTF-8"
                            } })
                    .then(response => {
                      console.log('Cópia do email enviada para a gestão com sucesso!');
                    })
                    .catch(error => {
                      console.log('Erro ao enviar cópia do email para a gestão: ' + error.message);
                    });
                  }
                }
                
                setIsLoadingMOD(false);
                campos.cntNome = '';
                campos.cntEmail = '';
                campos.cntMensagem = '';
                window.location.href = '/';
              })
              .catch(error => {
                alert('Erro ao enviar email de notificação: ' + error.message);
                setIsLoadingMOD(false);
              });
            }
          })
          .catch(error => {
            alert('(a) Ocorreu um erro ao enviar o formulário. Por favor, tente novamente mais tarde.' + error.message);
            setIsLoadingMOD(false);
          })
        })
        .catch(error => {
          alert('(b) Ocorreu um erro ao enviar o formulário. Por favor, tente novamente mais tarde.' + error.message);
          setIsLoadingMOD(false);
        });
  }

  function handleFormSubmitResposta(event) {
    event.preventDefault();
    setIsLoadingMOD(true);

    if (!campos.novaResposta) {
      alert('Por favor, preencha o campo de nova resposta antes de enviar.');
      setIsLoadingMOD(false);
      return;
    }

    const dados = {
      IdContato: campos.IdContato,
      cntLidaPor: sessionStorage.nomeUsuario,
      cntLidaEm: customFormatDate,
      cntObservacoes: 'Resposta em ' + customFormatDate + ', por ' + sessionStorage.nomeUsuario + ': ' + campos.novaResposta
    };

    axios
    .post(process.env.REACT_APP_API_URL +
        '/routes.php?metodo=responderContato', 
        dados, 
        { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } })
        .then(response => {
          //console.log(response); return;
          alert('Resposta enviada com sucesso!');// + response.message);          
          //campos.novaResposta = '';

          // Enviar email de notificação para o usuário que fez o contato
          let mess = '<div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; padding: 10px;">' +
          '<p>Olá </p>' + contato.cntNome + ', ' +
          '<p>responderam sua mensagem enviada pelo formulário de contato com o seguinte conteúdo: </p>' +
          '<p>' + campos.novaResposta + '</p>' +
          '</div>';

          const dadosEmail = {
            nome: contato.cntNome,
            email: contato.cntEmail,
            assunto: 'MGBE - Resposta ao seu contato',
            mensagem: mess
          };
          axios.post(process.env.REACT_APP_API_URL +
          '/routes.php?metodo=enviarEmail', 
          dadosEmail, 
          { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } })
          .then(response => {
            alert('Email de notificação enviado com sucesso!');
            setIsLoadingMOD(false);
          })
          .catch(error => {
            alert('Erro ao enviar email de notificação:' + error.message);
            setIsLoadingMOD(false);
          });

          window.history.back();
      })
      .catch(error => {
        alert('Ocorreu um erro ao enviar a resposta. Por favor, tente novamente mais tarde.' + error.message);
        setIsLoadingMOD(false);
      });
  }

  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Contato",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

  const telefone = '5511920049313';
  const mensagem = encodeURIComponent('Olá! Gostaria de mais informações sobre o Brasil Extremos.');
  const linkWhatsApp = `https://wa.me/${telefone}?text=${mensagem}`;

  const [pessoasAlerta, setPessoasAlerta] = useState([]);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + `/routes.php?metodo=obtemPessoasAlerta`
        , 
          { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } }
      )
      .then(response => {
        if (response.data && Array.isArray(response.data)) {
          setPessoasAlerta(response.data);
        }
      })
      .catch(error => {
        console.log('Erro ao obter pessoas de alerta: ' + error.message);
      });
  }, []);
//console.log(pessoasAlerta);
  return (
    <div style={{ paddingBottom: '80px' }}>
      <main>
        <div className='headerMain'>
          <label className='labelTitulo' ><h2>{parseInt(idcontato) > 0 ? 'Resposta ao Contato' : 'Formulário de Contato'}</h2></label>
          {/* <h2 className='title d-none'>Entre em Contato Conosco</h2> */}
        </div>
        <form style={{ padding: "20px" }} className="d-flex flex-column w100 text-align-left" onSubmit={handleFormSubmit} >
          <div className="d-flex flex-column divForm">
            <div className='text-align-center w100 divForm fs16' style={{ display: idcontato && parseInt(idcontato) > 0 ? 'none' : 'block' }}>
              <p className='text'>Se você tiver alguma dúvida, sugestão ou quiser saber mais sobre o Moto Grupo Brasil Extremos, não hesite em entrar em contato conosco!</p>
              <br />
              <p className='text'>Você pode nos enviar um e-mail para: <a style={{textDecoration: 'none', color: "#FFF"}} href="mailto:contato@brasilextremos.com.br">contato@brasilextremos.com.br</a>.</p>
              <br />
              <p className='text'>Ou, se preferir, nos enviar uma mensagem diretamente pelo WhatsApp :</p>
              <a href={linkWhatsApp} target="_blank" rel="noopener noreferrer" className="buttonModalPadrao p1 mt1" style={{ textDecoration: 'none', display: 'inline-block' }}>
                Enviar Mensagem pelo WhatsApp {<WhatsApp style={{ marginLeft: '0.4em', height: '1em', marginBottom: '-5px' }} />}
              </a>
            </div>
            <div className="w100 text-align-left mt2">
              <div className="text-align-left" style={{ textAlign: 'left' }}>
                <label className='labelTitulo' >Nome:</label>
              </div>
              <input type="text" name="cntNome" defaultValue={campos.cntNome} onChange={handleInputChange} required className="p1 mt1 bgGray fs12 w100" />
            </div>
            <div className="w100 text-align-left mt2">
              <div className="text-align-left" style={{ textAlign: 'left' }}>
                <label className='labelTitulo' style={{ textAlign: 'left' }} >E-mail:</label>
              </div>
              <input type="email" name="cntEmail" defaultValue={campos.cntEmail} onChange={handleInputChange} required className="p1 mt1 bgGray fs12 w100" />
            </div>
            <div className="w100 text-align-left mt2">
              <div className="text-align-left" style={{ textAlign: 'left' }}>
                <label className='labelTitulo' style={{ textAlign: 'left' }} >Mensagem:</label>
              </div>
              <textarea name="cntMensagem" defaultValue={campos.cntMensagem} onChange={handleInputChange} required className="p1 mt1 bgGray fs12 w100" rows="5"></textarea>
            </div>
            <div className="d-flex flex-column w100 mt2">
              {isLoadingMOD ? (
                <div className="d-flex flex-column w100 text-align-center">
                  <CircularProgress />
                  <span>Aguarde...</span>
                </div>
              ) : idcontato && idcontato > 0 ? '' : <button type="submit" className="buttonModalPadrao p1">Enviar</button>}
              
            </div>
          </div>
        </form>
        {/* Respostas do contato */}
            {idcontato && idcontato > 0 ? (
              <>
              <form style={{ padding: "20px" }} className="d-flex flex-column w100 text-align-left" onSubmit={handleFormSubmitResposta} >
                <div className="d-flex flex-column divForm mt2">
                  <div className="text-align-left" style={{ textAlign: 'left' }}>
                  <label className='labelTitulo' style={{ textAlign: 'left' }} >Respostas</label>
                  </div>
                  <textarea name="cntObservacoes" 
                  defaultValue={
                    campos.cntObservacoes
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')
                    .replace('</ br>', '\n')} 
                    onChange={handleInputChange} 
                    className="p1 mt1 bgGray fs12 w100" rows="5" autoResize="true"></textarea>
                </div>
                <div className="d-flex flex-column divForm mt2">
                  <div className="text-align-left" style={{ textAlign: 'left' }}>
                    <label className='labelTitulo' style={{ textAlign: 'left' }} >Nova Resposta</label>
                  </div>
                  <textarea name="novaResposta" defaultValue={campos.novaResposta} required onChange={handleInputChange} className="p1 mt1 bgGray fs12 w100 input-container" rows="5" autoResize="true"></textarea>
                </div>
                {isLoadingMOD ? (
                  <div className="d-flex flex-column w100 text-align-center">
                    <CircularProgress />
                    <span>Aguarde...</span>
                  </div>
                ) : 
                <div>
                  <button type="button" className="buttonGridPadrao2 p1 mr2" onClick={() => navigate(-1)}>Voltar</button>
                  <button type="submit" className="buttonModalSubmit p1">Enviar</button>
                </div>}
              </form>
              </>
            ) : ''}
        
      </main>
    </div>
  );
}

export default Contato;